import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { LoadingService } from '@core/services';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit, OnDestroy {

  private subscription: Subscription;
  public hidden: any;

  constructor(private _loadingService: LoadingService) {
  }

  ngOnInit() {
    this.subscription = this._loadingService.getHiddenValue().subscribe(isHidden => {
      this.hidden = isHidden;
    });

  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/loading/loading.component.ts